// extracted by mini-css-extract-plugin
export default {"wrapper":"Items_wrapper__mW419"};